import { DEFAULT_DASHBOARD_KEY, GLOBAL_DASHBOARD_KEY } from '../containers/Dashboard/constants';

export const getLoadedDashboardsInfo = (code) => {
  switch (code) {
    case DEFAULT_DASHBOARD_KEY: {
      return { userSpecificDashboard: false, globalDefaultDashboard: false };
    }
    case GLOBAL_DASHBOARD_KEY: {
      return { userSpecificDashboard: false, globalDefaultDashboard: true };
    }
    default: {
      return { userSpecificDashboard: true, globalDefaultDashboard: false };
    }
  }
};

export const getCurrentLoadedDashboardInfo = (code) => {
  switch (code) {
    case DEFAULT_DASHBOARD_KEY: {
      return { systemDefaultDashboard: true };
    }
    case GLOBAL_DASHBOARD_KEY: {
      return { globalDefaultDashboard: true };
    }
    default: {
      return { userSpecificDashboard: true };
    }
  }
};
